import { Component } from '@angular/core';
import { CourseService } from '../services/course.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-add-new-assessment',
  templateUrl: './add-new-assessment.component.html',
  styleUrls: ['./add-new-assessment.component.css']
})
export class AddNewAssessmentComponent {

  assessmentNameList: any = [];
  assessmentIDList: any = [];
  topicIDList: any = [];

  addAssessmentReqObj: { testNameId: any, testId: any, newTestId: any, topicId: any, newTopicId: any, newCourseId: any } = { testNameId: '', testId: 0, newTestId: '', topicId: 0, newTopicId: '', newCourseId: '' }

  constructor(private readonly courseService: CourseService, private readonly toastr: ToastrService) { }

  ngOnInit() {
    this.getAssessmentName();
  }

  getAssessmentName() {
    this.courseService.getAssessmentName().subscribe({
      next: data => {
        this.assessmentNameList = data;
      },
      error: error => {
      }
    })
  }

  getAssessmentId() {
    this.courseService.getAssessmentId(this.addAssessmentReqObj.testNameId).subscribe({
      next: data => {
        this.assessmentIDList = data;
      },
      error: error => {

      }
    })
  }

  getTopicId() {
    this.courseService.getTopicId(this.addAssessmentReqObj.testId).subscribe({
      next: data => {
        this.topicIDList = data;
      },
      error: error => {

      }
    })
  }

  addAssessment() {
    console.log(this.addAssessmentReqObj);
    this.courseService.addAssessement(this.addAssessmentReqObj).subscribe({
      next: data => {
        this.toastr.success('Assessment was added successfully.', 'Success!');
        this.addAssessmentReqObj = {
          testNameId: '', testId: 0, newTestId: '', topicId: 0, newTopicId: '', newCourseId: ''
        };
      },
      error: error => {
        this.toastr.error('Assessment could not be added. Please try again later.', 'Error!');
      }
    })
  }
}
